import { Component } from '@angular/core';
import { PimProductBasicInfoComponent } from 'gung-standard';

@Component({
    selector: 'colmec-pim-product-basic-info',
    templateUrl: './colmec-pim-product-basic-info.component.html',
    styleUrl: './colmec-pim-product-basic-info.component.scss',
    standalone: false
})
export class ColmecPimProductBasicInfoComponent extends PimProductBasicInfoComponent {

}
